import { CalendarSettings, SchedulingPreference } from "./Calendar.model";

export class CalendarHelper {
  public static setDefaultsIfNotSet(calendarSettings: CalendarSettings): void {
    if (!calendarSettings.schedulingPreference) {
      calendarSettings.schedulingPreference = SchedulingPreference.MANUAL;
    }

    if (!calendarSettings.schedule) {
      calendarSettings.schedule = {};
    }

    if (!calendarSettings.unavailabilitySettings) {
      calendarSettings.unavailabilitySettings = { unavailableDurations: [] };
    }

    let schedule = calendarSettings.schedule;

    if (!schedule.monday) {
      schedule.monday = {
        timeSlots: [{ start: { h: 9, m: 0 }, end: { h: 17, m: 0 } }],
      };
    }

    if (!schedule.tuesday) {
      schedule.tuesday = {
        timeSlots: [{ start: { h: 9, m: 0 }, end: { h: 17, m: 0 } }],
      };
    }

    if (!schedule.wednesday) {
      schedule.wednesday = {
        timeSlots: [{ start: { h: 9, m: 0 }, end: { h: 17, m: 0 } }],
      };
    }

    if (!schedule.thursday) {
      schedule.thursday = {
        timeSlots: [{ start: { h: 9, m: 0 }, end: { h: 17, m: 0 } }],
      };
    }

    if (!schedule.friday) {
      schedule.friday = {
        timeSlots: [{ start: { h: 9, m: 0 }, end: { h: 17, m: 0 } }],
      };
    }

    if (!schedule.saturday) {
      schedule.saturday = { timeSlots: [] };
    }

    if (!schedule.sunday) {
      schedule.sunday = { timeSlots: [] };
    }
    if (!calendarSettings.reschedulingSettings) {
      calendarSettings.reschedulingSettings = {
        maxReschedulesAllowedByMentees: 2,
        rescheduleAllowed: true,
        rescheduleAllowedUntilSecs: 86400,
      };
    } else if (calendarSettings.reschedulingSettings.rescheduleAllowed === undefined || calendarSettings.reschedulingSettings.rescheduleAllowed === null) {
      calendarSettings.reschedulingSettings.rescheduleAllowed = true;
    }

    if (!calendarSettings.cancellationSettings) {
      calendarSettings.cancellationSettings = {
        cancellationAllowed: true,
      };
    }
  }
}
